import { openDB } from "idb";

export const dbPromise = openDB("scannerDB", 2, {
  upgrade(db, oldVersion) {
    console.log("🧱 [IDB] upgrade from", oldVersion);

    if (db.objectStoreNames.contains("orders")) {
      db.deleteObjectStore("orders");
    }

    const store = db.createObjectStore("orders", {
      keyPath: ["tracking_id", "account"], // ✅ composite key
    });

    store.createIndex("tracking_id", "tracking_id"); // ✅ needed
    store.createIndex("scanned_on", "scanned_on");

    if (!db.objectStoreNames.contains("scanQueue")) {
      db.createObjectStore("scanQueue", { autoIncrement: true });
    }
  },
});

/* ───────── ORDERS ───────── */

export const putOrders = async (orders) => {
  console.log("🟢 [IDB] putOrders start", orders.length);

  const db = await dbPromise;
  const tx = db.transaction("orders", "readwrite");
  const store = tx.objectStore("orders");

  for (const o of orders) {
    if (!o.tracking_id || !o.account) continue;
    store.put(o);
  }

  await tx.done;
  console.log("✅ [IDB] putOrders done");
};

export const getOrder = async (tracking_id) => {
  if (!tracking_id) return null;

  const db = await dbPromise;
  const index = db.transaction("orders").store.index("tracking_id");
  const results = await index.getAll(tracking_id);

  return results?.[0] || null; // ✅ works with composite key
};

export const clearOrders = async () => {
  const db = await dbPromise;
  const tx = db.transaction("orders", "readwrite");
  await tx.store.clear();
  await tx.done;
};

/* ───────── QUEUE ───────── */

export const addToQueue = async (item) => {
  const db = await dbPromise;
  const id = await db.add("scanQueue", item);
  return id; // ✅ return autoIncrement key
};


export const getQueue = async () => {
  const db = await dbPromise;
  const tx = db.transaction("scanQueue");
  const store = tx.objectStore("scanQueue");

  const items = [];
  let cursor = await store.openCursor();

  while (cursor) {
    items.push({
      __key: cursor.key, // ✅ REQUIRED
      ...cursor.value,
    });
    cursor = await cursor.continue();
  }

  return items;
};


export const removeFromQueue = async (id) =>
  (await dbPromise).delete("scanQueue", id);

export const clearQueue = async () => {
  const db = await dbPromise;
  const tx = db.transaction("scanQueue", "readwrite");
  await tx.store.clear();
  await tx.done;
};
